import React from 'react'

export const ObserveBoxSettings = props => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
